import { playUiClick } from '../../../assets/preloadSounds';
import flashImg from '../../components/atomic/buttons/button/flash.png';
import goBackIconImg from './go_back_icon.png';
import goBackTextImg from './go_back_button_text.png';
import './GoBackButton.css';

type GoBackButtonProps = {
  onClick?: () => void;
};

/** Figma go_back_button (161:23926) — wide purple CTA with home icon + label. */
export function GoBackButton({ onClick }: GoBackButtonProps) {
  return (
    <button
      type="button"
      className="quiz-go-back-button"
      aria-label="Вернуться назад"
      onClick={() => {
        playUiClick();
        onClick?.();
      }}
    >
      <img
        className="quiz-go-back-button__flash"
        src={flashImg}
        alt=""
        draggable={false}
      />
      <img
        className="quiz-go-back-button__icon"
        src={goBackIconImg}
        alt=""
        draggable={false}
      />
      <img
        className="quiz-go-back-button__text"
        src={goBackTextImg}
        alt=""
        draggable={false}
      />
    </button>
  );
}
